var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackLoginOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85562 11.2008V8.19413C4.85562 8.19413 4.80943 7.93053 5.41549 7.60835L11.3972 3.52931V6.68012L4.85562 11.1996V11.2008Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1446 11.2008V8.19413C18.1446 8.19413 18.1908 7.93053 17.5848 7.60835L11.6031 3.52931V6.68012L18.1446 11.1996V11.2008Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85536 15.9568L7.55332 14.6816L11.0398 17.063C11.2494 17.1892 11.3823 17.4111 11.3947 17.6556V20.4707L4.85536 15.9579V15.9568Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1446 15.9568L15.4467 14.6816L11.9602 17.063C11.7506 17.1892 11.6177 17.4111 11.6053 17.6556V20.4707L18.1446 15.9579V15.9568Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85536 11.7854C4.87789 11.4891 5.03335 11.2199 5.27667 11.0509L7.34379 9.59887C7.34379 9.59887 7.53417 9.54593 7.53417 9.73067V14.5341L4.85649 15.843V11.7854H4.85424H4.85536Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1446 11.7854C18.1221 11.4891 17.9667 11.2199 17.7233 11.0509L15.6562 9.59887C15.6562 9.59887 15.4658 9.54593 15.4658 9.73067V14.5341L18.1435 15.843V11.7854H18.1458H18.1446Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19237 14.106V13.9967L10.7053 13.3107L12.0616 13.9708V13.7759L10.7075 13.1158L9.19125 13.803V13.4211L10.7041 12.7339L12.0604 13.394V13.1992L10.7064 12.539L9.19012 13.2273V12.8973L10.703 12.2101L12.0593 12.8668V12.6765L10.7053 12.0163L9.18899 12.7046V12.3171L10.7019 11.6311L12.0582 12.2912V12.0963L10.7041 11.4362L9.18787 12.1245V11.6446L10.7008 10.9586L12.0571 11.6063V11.4238L10.703 10.7637L9.18674 11.4508V10.998L10.6996 10.3108L12.0559 10.9552V10.7761L10.7019 10.1159L9.18561 10.8042V10.4426L10.6985 9.75658L12.0548 10.3762V10.2218L10.7008 9.5617L9.1169 10.2793H8.8533V14.106H7.88789V14.5352H15.058V14.106H9.19237Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7492 9.44229L11.5625 9.19221V9.72054L13.5654 10.6792V10.8594L12.4389 10.3412V10.5361L13.5654 11.0543V11.274L12.4389 10.8707V11.0611L13.5654 11.4644V11.7922L12.4389 11.5139V11.6964L13.5654 11.9747V12.3182L12.4389 12.1357V12.3182L13.5654 12.5007V12.8128L12.4389 12.7193V12.895L13.5654 12.9885V13.3287L12.4389 13.251V13.4267L13.5654 13.5044V13.7872H12.4389V13.9629H13.5654V14.2547H13.8257V9.11899H13.5654V9.16292L11.674 7.95194L10.7458 8.23694H10.6005V9.44004H10.7458L10.7481 9.44229H10.7492ZM11.7484 8.21328L13.5654 9.37695V9.61352L11.7484 8.52082V8.21328ZM11.7484 8.72584L13.5654 9.81854V10.0686L11.7484 9.01985V8.72584ZM11.7484 9.22262L13.5654 10.2714V10.482L11.7484 9.61239V9.22262ZM10.765 8.41605L11.5625 8.1716V8.5073L10.765 8.75175V8.41605ZM10.765 8.93537L11.5625 8.69092V9.00972L10.765 9.25417V8.93537Z",
    fill: "#030712"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackLoginOptions);
export default __webpack_public_path__ + "static/media/ic-back-login-options.325ed72e466b33af537fb06d1155858b.svg";
export { ForwardRef as ReactComponent };